// Only bundle the German locale from Zod to avoid shipping all 50+ locales (~1.2 MB).
// This file is aliased in vite.config.ts to replace zod's locale index.
// See: https://github.com/colinhacks/zod/issues/5561
export { default as de } from 'zod/v4/locales/de.js';
export { default as en } from 'zod/v4/locales/en.js';
